<template>
  <div class="reg-form-wrap">
    <div class="form">
      <div class="form-title">
        <h4>Вход</h4>
        <div class="descriprion">
          <span>С возвращением!</span>
          <span>Пожалуйста, зайдите в свой аккаунт</span>
        </div>
      </div>
      <div class="input-group-wrap">
        <Inputs
          ref="user_phone"
          placeholder="Телефон"
          class="phone-input"
          name="user_phone"
          @enter="login"
          subholder="Телефон"
        ></Inputs>
        <Inputs
          ref="user_password"
          type="password"
          name="user_pass"
          placeholder="Пароль"
          subholder="Пароль"
          class="password-input"
          @enter="login"
        ></Inputs>
      </div>
      <div class="submit-group">
        <div class="btn-wrap">
          <Buttons class="btn-primary" @click="login">Войти</Buttons>
        </div>
        <!--<div class="or-line-wrap">
          <div class="or-line"></div>
        </div>
        <div class="social-reg-wrap">
          <Buttons class="btn-fb">
            <a
              href="https://www.facebook.com/v2.8/dialog/oauth?client_id=1357470747748293&redirect_uri=https://fotty.ru/api/user/v1/social/fb&response_type=code&state=https://fotty.ru/auth/registration/"
            >Фейсбук</a>
          </Buttons>
          <Buttons class="btn-vk">
            <a
              href="https://oauth.vk.com/authorize?client_id=7188111&redirect_uri=https://fotty.ru/api/user/v1/social/vk&response_type=code&state=https://fotty.ru/auth/registration/"
            >Вконтакте</a>
          </Buttons>
        </div>-->
        <div class="under-form">
          Еще нет аккаунта?
          <router-link to="/auth/registration/">Зарегистрируйтесь</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Inputs from "@/components/basic/Input.vue";
import Inputmask from "inputmask";
import Buttons from "@/components/basic/Fbuttons.vue";
import { tokenMethods } from "@/library/lib.js";

export default {
  name: "LoginForm",
  components: {
    Inputs,
    Buttons
  },
  data() {
    return {};
  },
  methods: {
    login: function() {
      let request = {
        password: this.$refs.user_password.getValue() || "",
        phone: this.$refs.user_phone.getValue() || ""
      };
      if (!request.phone) {
        return;
      }
      if (!request.password) {
        return;
      }

      this.$store
        .dispatch("user/login", request)
        .then(response => {

          tokenMethods.setToken(response.data.token);

          this.$store.commit("user/SET_USER_WITH_PREPARE", response);
          this.$store.dispatch("events/init");
          this.$router.push({
            path: "/profile"
          });
        })
        .catch(error => {
          switch (error.response.status) {
            case 404:
              this.$notify({
                group: "error",
                title: "Ошибка авторизации",
                text: "Пользователь с таким паролем не нейден"
              });
              return;
            case 502:
              this.$notify({
                group: "error",
                title: "Ошибка запроса",
                text: "Сетевой ресурс не найден"
              });
              return;
            default:
              return;
          }
        });
    }
  },
  mounted: function() {
    this.$refs.user_phone.setAttr("autocomplete", "off");
    this.$refs.user_phone.setAttr("pattern", "\\d*");
    this.$refs.user_phone.setAttr("inputmode", "numeric");

    let im = new Inputmask({
        mask: "+7 999 999 99 99",
        placeholder: "+7 ___ ___ __ __"
      }),
      _inp = this.$refs.user_phone.getInput();

    im.mask(_inp);
    _inp.focus();
    _inp.blur();
    this.$refs.user_phone.getValue = function() {
      return _inp.inputmask.isComplete()
        ? "7" + _inp.inputmask.unmaskedvalue()
        : "";
    };
  }
};
</script>

<style lang="scss">
.reg-form-wrap {
  display: grid;
  height: 100%;

  .form {
    align-self: center;
    justify-self: center;
    text-align: center;
    max-width: 376px;
    width: 100%;

    .form-title {
      text-align: center;
      margin-bottom: 56px;
      @media (max-width: 360px) {
        margin-bottom: 20px;
      }
      h4 {
        font-weight: bold;
        font-size: 32px;
        line-height: 40px;
        text-align: center;
        color: #333333;
        margin-bottom: 8px;
      }
      .descriprion {
        font-size: 16px;
        line-height: 24px;
        color: #8e8e8e;
        span {
          display: block;
        }
      }
    }
    .phone-input {
      margin-bottom: 50px;
      @media (max-width: 360px) {
        margin-bottom: 20px;
      }
      input {
        &:not(:placeholder-shown),
        &:hover {
          letter-spacing: 1px;
        }
      }
    }
    .password-input {
      // position: relative;
    }
  }
  .submit-group {
    margin-top: 56px;
    .confirm-line {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .input-line {
        display: flex;
        align-items: center;
      }

      label {
        margin-bottom: 0;
      }
    }
  }
  .btn-wrap {
    button {
      width: 100%;
      padding: 16px 0;
    }
    margin-bottom: 36px;
  }
  .or-line-wrap {
    width: 100%;
    position: relative;
    height: 24px;
    margin-bottom: 12px;
    .or-line {
      height: 1px;
      width: 100%;
      background-color: #e0e0e0;
      &:after {
        content: "или";
        position: absolute;
        font-size: 16px;
        line-height: 24px;
        color: $calmColor;
        background-color: #fff;
        left: calc(50% - 20px);
        padding: 0 4px;
        top: -12px;
      }
    }
  }
  .social-reg-wrap {
    display: grid;
    grid-column-gap: 16px;
    grid-template-columns: 1fr 1fr;
    // flex-wrap: wrap;
    button {
      & ~ button {
        // margin-left:
      }
    }
  }
  .under-form {
    font-size: 16px;
    line-height: 24px;
    margin-top: 24px;
    a {
      font-weight: 500;
    }
  }
}
</style>
